var render, staticRenderFns
import script from "./GridContextMenuOptionsMixin.vue?vue&type=script&lang=ts"
export * from "./GridContextMenuOptionsMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f1ef27')) {
      api.createRecord('16f1ef27', component.options)
    } else {
      api.reload('16f1ef27', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/GridContextMenuOptionsMixin.vue"
export default component.exports